// extracted by mini-css-extract-plugin
export default {"checker":"GXmVzL","size-20":"yw8bmw","size-22":"hjcJBs","size-24":"rIHCz8","size-26":"dO__SU","label":"kHa0lf"};